import {IonContent} from "@ionic/react";
import AdminEntityList from "./AdminEntityList";

export const AdminManageUserPermissions = ({userId}) => {
    return (
        <IonContent fullscreen>
            <AdminEntityList />
        </IonContent>
    );
}